import React, { useState } from "react";
import { FmIcon, FmBlackPopup } from "..";
import BottomDrawer from "../../Pages/SavedItems/BottomDrawer/BottomDrawer";
import { useIsLaptop, useIsMobile, useTheme } from "../../Hooks";
import { FmDeleteItemModal } from "../Modals/FmDeleteItemModal";
import useStyles from "./FmEditPopup.style";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AgriSolutionState } from "../../Redux";

interface FmEditPopupProps {
  title: string;
  onDelete: () => void;
  onUpdate: () => void;
}

const FmEditPopup = ({ title, onDelete, onUpdate }: FmEditPopupProps) => {
  const [displayDeleteModel, setDisplayDeleteModel] = useState<boolean>(false);
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useIsMobile();
  const isLaptop = useIsLaptop();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [ShowBlackSnackbar, setShowBlackSnackbar] = useState<boolean>(false);
  const stepIndexPage = useSelector(AgriSolutionState.Selectors.selectStepIndexPage);
  const _onDelete = () => {
    setDisplayDeleteModel(false);
    onDelete();
  };

  const closeDeleteModal = () => {
    setDisplayDeleteModel(false);
  };
  const openDeleteModal = () => {
    setDisplayDeleteModel(true);
  };
  const closeSnackbarHandler = () => {
    setShowBlackSnackbar(false);
  };
  const _onUpdate = () => {
    setShowBlackSnackbar(true);
    dispatch(AgriSolutionState.Actions.setStepIndexPage(stepIndexPage));
    onUpdate();
  };
  return (
    <>
      {isMobile ? (
        <div className={classes.mobile_container}>
          <div className={classes.lightFontWeight}>{t("pageStep5.bottomDrawer.savedItem")}</div>
          <span>
            <BottomDrawer imgUrl={theme.images.actionWhite}>
              <div className={classes.bottomDrawer_container}>
                <span className={classes.bottomDrawer_span} onClick={openDeleteModal}>
                  {t("pageStep5.bottomDrawer.delete")}
                </span>

                <span className={classes.bottomDrawer_span} onClick={_onUpdate}>
                  {t("pageStep5.bottomDrawer.update")}
                </span>
              </div>
            </BottomDrawer>
          </span>
        </div>
      ) : (
        <div className={isLaptop ? classes.laptop_container : classes.container}>
          <div className={classes.leftSide}>
            <span className={classes.bigFont}>{title}</span>
            <span className={classes.mediumFont}>/{t("pageStep5.bottomDrawer.savedItem")} </span>
          </div>
          <div className={classes.rightSide}>
            <div className={classes.imgLabel_container} onClick={openDeleteModal}>
              <FmIcon url={theme.images.deleteWhite} />
              <span className={classes.lightFontWeight}>{t("pageStep5.bottomDrawer.delete")}</span>
            </div>

            <div className={classes.imgLabel_container} onClick={_onUpdate}>
              <FmIcon url={theme.images.update} />
              <span className={classes.lightFontWeight}>{t("pageStep5.bottomDrawer.update")}</span>
            </div>
          </div>
          <FmDeleteItemModal img={theme.images.clearModalImage} isOpen={displayDeleteModel} onClose={closeDeleteModal} onAction={_onDelete} />
          {ShowBlackSnackbar && (
            <div className={classes.snackbar_container}>
              <FmBlackPopup text={t("saveItemPopup.snackbar")} snackbar={true} onClose={closeSnackbarHandler} />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default FmEditPopup;
